import { getCookie } from 'utils';

export const getUserIdFromCookie = () =>
  // idl - userId cookie set for leap.cuemath.com
  getCookie('idl');

export const getStudentServiceIdFromCookie = () =>
  // idl - userId cookie set for leap.cuemath.com
  getCookie('ssidl');
